<div class="super-latex-wrapper" [ngClass]="customCss()" [ngStyle]="customStyle() ?? {}">
  <dojo-super-latex [content]="content()" />
  <button class="edit-btn" (click)="openEditor()" title="Edit SuperLatex">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
    </svg>
  </button>
</div>

<ion-modal
  cssClass="super-latex-editor-modal"
  [isOpen]="showEditor()"
  [backdropDismiss]="true"
  (didDismiss)="closeEditor()"
>
  <ng-template>
    <ion-content [scrollY]="false">
      <dojo-super-latex-editor
        [content]="content()"
        (contentChange)="onContentChange($event)"
        (editorClose)="closeEditor()"
      />
    </ion-content>
  </ng-template>
</ion-modal>
